/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Meta_DescriptionInputs */

const en_start_page_meta_description = /** @type {(inputs: Start_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover and fund a personalized Glider portfolio.`)
};

const de_start_page_meta_description = /** @type {(inputs: Start_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecken und finanzieren Sie ein personalisiertes Glider-Portfolio.`)
};

const pt_br2_start_page_meta_description = /** @type {(inputs: Start_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubra e financie um portfólio personalizado da Glider.`)
};

const tr_start_page_meta_description = /** @type {(inputs: Start_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kişiselleştirilmiş Glider portföyünüzü keşfedin ve fonlayın.`)
};

const zh_cn2_start_page_meta_description = /** @type {(inputs: Start_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现并为个性化的 Glider 投资组合注资。`)
};

const zh_hk2_start_page_meta_description = /** @type {(inputs: Start_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索並為個人化的 Glider 投資組合注資。`)
};

const ko_kr2_start_page_meta_description = /** @type {(inputs: Start_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나만의 Glider 포트폴리오를 찾고 자금을 예치하세요.`)
};

const ru_ru2_start_page_meta_description = /** @type {(inputs: Start_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подберите и пополните персональный портфель Glider.`)
};

const es_419_start_page_meta_description = /** @type {(inputs: Start_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubre y financia un portafolio personalizado de Glider.`)
};

/**
* | output |
* | --- |
* | "Discover and fund a personalized Glider portfolio." |
*
* @param {Start_Page_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const start_page_meta_description = /** @type {((inputs?: Start_Page_Meta_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Meta_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_start_page_meta_description(inputs)
	if (locale === "de") return de_start_page_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_start_page_meta_description(inputs)
	if (locale === "tr") return tr_start_page_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_start_page_meta_description(inputs)
	if (locale === "zh-HK") return zh_hk2_start_page_meta_description(inputs)
	if (locale === "ko-KR") return ko_kr2_start_page_meta_description(inputs)
	if (locale === "ru-RU") return ru_ru2_start_page_meta_description(inputs)
	return es_419_start_page_meta_description(inputs)
});